import { useState } from 'react';

export const useLanguage = () => {
  // Always use English - kept for future translation support
  // forceRenderKey kept for component key stability (even though always 0 now)
  const [forceRenderKey] = useState(0);

  return {
    currentLanguage: 'en', // Always English
    forceRenderKey,
  };
};
